module.exports = __webpack_public_path__ + "img/desert-colada.f6b68a86.jpg";